import { Check } from 'lucide-react';
import type { TrainingOption } from '@hcc/types';

/** Multi-select answer: full-width tappable rows, any number selectable. */
export function CheckboxAnswer({
  options,
  value,
  onChange,
  disabled,
  ariaLabelledBy,
}: {
  options: TrainingOption[];
  value: string[] | undefined;
  onChange: (next: string[]) => void;
  disabled?: boolean;
  ariaLabelledBy?: string;
}) {
  const selected = value ?? [];
  function toggle(id: string) {
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  }
  return (
    <div role="group" aria-labelledby={ariaLabelledBy} className="flex flex-col gap-2">
      {options.map((o) => {
        const on = selected.includes(o.id);
        return (
          <button
            key={o.id}
            type="button"
            role="checkbox"
            aria-checked={on}
            disabled={disabled}
            onClick={() => toggle(o.id)}
            className={`flex min-h-[44px] w-full items-center gap-3 rounded-token-sm border px-4 py-3 text-left text-sm transition-colors disabled:opacity-60 ${
              on
                ? 'border-accent bg-accent/10 text-fg'
                : 'border-line/10 bg-surface text-fg hover:bg-surface-2'
            }`}
          >
            <span
              aria-hidden
              className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-token-sm border-2 ${
                on ? 'border-accent bg-accent text-fg-on-accent' : 'border-line-strong/40'
              }`}
            >
              {on ? <Check className="h-3.5 w-3.5" /> : null}
            </span>
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
